export type Language = 'en' | 'pt';

export const translations = {
  en: {
    nav: {
      home: 'Home',
      portfolio: 'Portfolio',
      stlModels: 'STL Models',
      contact: 'Contact',
    },
    home: {
      title: 'Welcome to CraftiCore',
      subtitle: 'Your Premier 3D Printing Service Provider',
      cta: 'Get a Quote',
      services: {
        prints: {
          title: 'High-Quality Prints',
          description: 'State-of-the-art 3D printers and premium materials ensure the highest quality results for your projects.',
        },
        turnaround: {
          title: 'Fast Turnaround',
          description: 'Quick processing and efficient production mean you get your prints when you need them.',
        },
        support: {
          title: 'Expert Support',
          description: 'Our team of experienced professionals is here to help with design optimization and technical advice.',
        },
      },
    },
    portfolio: {
      title: 'Our Portfolio',
      subtitle: 'Showcasing Our Best Work',
    },
    stlModels: {
      title: 'STL Models',
      subtitle: 'Ready-to-Print 3D Models',
      uploadButton: 'Upload Your Model',
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in Touch',
      info: {
        title: 'Contact Information',
        email: 'Email',
        instagram: 'Instagram',
      },
      form: {
        title: 'Send Us a Message',
        name: 'Name',
        email: 'Email',
        subject: 'Subject',
        message: 'Message',
        submit: 'Send Message',
      },
    },
  },
  pt: {
    nav: {
      home: 'Início',
      portfolio: 'Portfólio',
      stlModels: 'Modelos STL',
      contact: 'Contato',
    },
    home: {
      title: 'Bem-vindo à CraftiCore',
      subtitle: 'Seu Provedor Premium de Serviços de Impressão 3D',
      cta: 'Solicitar Orçamento',
      services: {
        prints: {
          title: 'Impressões de Alta Qualidade',
          description: 'Impressoras 3D de última geração e materiais premium garantem os melhores resultados para seus projetos.',
        },
        turnaround: {
          title: 'Entrega Rápida',
          description: 'Processamento rápido e produção eficiente significam que você recebe suas impressões quando precisa.',
        },
        support: {
          title: 'Suporte Especializado',
          description: 'Nossa equipe de profissionais experientes está aqui para ajudar com otimização de design e aconselhamento técnico.',
        },
      },
    },
    portfolio: {
      title: 'Nosso Portfólio',
      subtitle: 'Exibindo Nossos Melhores Trabalhos',
    },
    stlModels: {
      title: 'Modelos STL',
      subtitle: 'Modelos 3D Prontos para Impressão',
      uploadButton: 'Enviar Seu Modelo',
    },
    contact: {
      title: 'Entre em Contato',
      subtitle: 'Fale Conosco',
      info: {
        title: 'Informações de Contato',
        email: 'E-mail',
        instagram: 'Instagram',
      },
      form: {
        title: 'Envie-nos uma Mensagem',
        name: 'Nome',
        email: 'E-mail',
        subject: 'Assunto',
        message: 'Mensagem',
        submit: 'Enviar Mensagem',
      },
    },
  },
}; 